import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/autobay/Navbar";
import Hero from "@/components/autobay/Hero";
import Marquee from "@/components/autobay/Marquee";
import Services from "@/components/autobay/Services";
import TowingSpotlight from "@/components/autobay/TowingSpotlight";
import Products from "@/components/autobay/Products";
import Partners from "@/components/autobay/Partners";
import Testimonials from "@/components/autobay/Testimonials";
import Contact from "@/components/autobay/Contact";
import Footer from "@/components/autobay/Footer";
import AuthCallback from "@/components/autobay/AuthCallback";
import Admin from "@/pages/Admin";

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <TowingSpotlight />
        <Products />
        <Partners />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -88, duration: 1.2 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
